<template>
  <main class="p-4 pt-14 lg:pt-20 min-h-screen">
    <section v-if="cart.length > 0" class="max-w-prose">
      <div v-for="item in cart" :key="item.id" class="mb-4">
        <div class="flex mb-2">
          <h1 class="flex-1 pr-4">{{ item.quantity }} × {{ item.title }}</h1>
          <h1>€ {{ item.price }}</h1>
        </div>
        <div class="flex">
          <div class="btn-container">
            <div
              class="btn active"
              :style="{ 'background-color': item.code }"
            ></div>
            <div class="btn active">
              {{ item.size }}
            </div>
            <div v-if="item.preorder" class="btn highlight">Pre-order</div>
          </div>
          <div class="flex-1"></div>
          <div class="btn active" @click="removeFromCart">Remove</div>
        </div>
        <div v-if="item.message" class="text-xs pt-2">{{ item.message }}</div>
      </div>
      <div class="mb-4">
        <div class="flex mb-4">
          <h1 class="flex-1 pr-4">Total</h1>
          <h1>€ {{ total }}</h1>
        </div>
        <p>Shipping is calculated upon checkout</p>
        <p v-if="defaultCountry">
          Country: {{ getCountryName() }} (<span
            class="link cursor-pointer"
            @click="openCountryModal"
            >Change?</span
          >)
        </p>
      </div>
      <k-layout :content="page.layout" />
      <div class="inline-block">
        <div class="btn-container">
          <div class="btn action" @click="checkout">Checkout</div>
        </div>
      </div>
    </section>
    <section v-else>
      <h1>Cart is empty</h1>
      <router-link :to="{ name: 'home' }"
        >Please go back to the shop</router-link
      >
    </section>

    <div
      v-if="countryModal"
      class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-75 p-4 z-50"
      @click.self="countryModal = false"
    >
      <div
        class="
          absolute
          btn-container
          w-full
          md:w-96
          top-1/2
          flex-col
          left-1/2
          transform
          p-4
          -translate-y-1/2 -translate-x-1/2
        "
      >
        <div class="mb-2">Choose Country</div>
        <div class="mb-4 w-full">
          <select
            class="w-full bg-gray-50 p-1"
            name="country"
            id="country-select"
            v-model="selected"
          >
            <option disabled value="0" selected>Please select one</option>
            <option
              v-for="country in selects"
              :key="country.code"
              :value="country.code"
            >
              {{ country.name }}
            </option>
          </select>
        </div>
        <div @click="changeCountry" class="w-auto self-start btn action">
          Change
        </div>
      </div>
    </div>
  </main>
</template>

<script>
const stripe = window.Stripe(process.env.VUE_APP_STRIPEKEY);
import axios from "axios";
import countries from "@/assets/countries.json";
import select from "@/assets/select.json";
const KLayout = () =>
  import(/* webpackChunkName: "KLayout" */ "@/components/Layout.vue");
export default {
  name: "cart",
  metaInfo() {
    return {
      title: "– Cart",
    };
  },
  data() {
    return {
      defaultCountry: "IT",
      shipping: [],
      countries: countries,
      countryModal: false,
      selects: select,
      selected: 0,
    };
  },
  created() {
    this.calculateShipping();
  },
  components: {
    KLayout,
  },
  computed: {
    page() {
      return this.$store.state.pages[this.$route.name];
    },
    cart() {
      return this.$store.state.cart;
    },
    total() {
      return this.$store.getters["totalAmount"];
    },
  },
  watch: {
    cart() {
      this.calculateShipping();
    },
  },
  methods: {
    getCountryName() {
      let find = select.find((item) => item.code == this.defaultCountry);
      return find ? find.name : "";
    },
    openCountryModal() {
      this.countryModal = true;
    },
    changeCountry() {
      this.defaultCountry = this.selected;
      this.calculateShipping();
      this.countryModal = false;
    },
    getRegion() {
      let region = null;
      for (var i = 0; i < this.countries.length; i++) {
        if (this.countries[i].countries.includes(this.defaultCountry)) {
          region = this.countries[i];
        }
      }
      return region;
    },
    calculateShipping() {
      this.shipping = this.getRegion();
    },
    checkout() {
      let items = Object.values(this.cart).map((item) => ({
        price_data: {
          currency: "eur",
          product_data: {
            name:
              item.title +
              " – Colour: " +
              item.colour +
              " – Size: " +
              item.size,
            metadata: {
              size: item.size,
              colour: item.colour,
            },
            description: item.message ? item.message : null,
            images: [item.img],
          },
          unit_amount: item.price * 100,
        },
        quantity: item.quantity,
      }));
      items.push({
        price_data: {
          currency: "eur",
          product_data: {
            name: "Shipping",
          },
          unit_amount: this.shipping.price,
        },
        quantity: 1,
      });
      axios
        .post(
          "/api/stripe/checkout/create",
          {
            items: items,
            shipping: this.shipping,
          },
          {
            auth: {
              username: process.env.VUE_APP_USERNAME,
              password: process.env.VUE_APP_PASSWORD,
            },
          }
        )
        .then((res) => {
          return stripe.redirectToCheckout({ sessionId: res.data.id });
        })
        .then((result) => {
          if (result.error) {
            alert(result.error.message);
          }
        });
    },
    removeFromCart(id) {
      this.$store.commit("removeFromCart", id);
    },
  },
};
</script>
